export const countdownTime = (currentTime: number, duration: number) => {
  const countdownSeconds = duration - currentTime
  const countdownMinute = Math.round(Number(countdownSeconds) / 60)
  const modulo = countdownSeconds / 60
  if (countdownMinute === 0 && modulo === 0) return 0
  if (countdownMinute === 0 && modulo > 0) return 1
  return countdownMinute
}
